import moment from 'moment-timezone';

moment.tz.setDefault("GMT");